import {
  IsString,
  IsNotEmpty,
  IsEmail,
  IsStrongPassword,
  isStrongPassword,
  ValidationArguments,
  NotEquals,
  Equals,
  MinLength,
  Matches,
} from "class-validator";
import { t as i18nValidationMessage } from "i18next";

import "@/locales/i18n";

export class CreateUserRequest {
  @IsString()
  @IsNotEmpty({ message: "This field cannot be empty" })
  username: string;
  @IsEmail(
    {},
    {
      message: i18nValidationMessage("validation:INVALID_EMAIL"),
    },
  )
  @IsNotEmpty({ message: i18nValidationMessage("validation:NOT_EMPTY") })
  email: string;
  @IsString()
  @IsNotEmpty({ message: i18nValidationMessage("validation:NOT_EMPTY") })
  @IsStrongPassword(
    {
      minLength: 8,
      minLowercase: 1,
      minUppercase: 1,
      minNumbers: 1,
      minSymbols: 1,
    },
    {
      message: (args: ValidationArguments) => {
        if (isStrongPassword(args.value, { minLength: 8 })) {
          return i18nValidationMessage(
            "validation:PASSWORD.minlength",
          ).toString();
        } else if (isStrongPassword(args.value, { minLowercase: 1 })) {
          return i18nValidationMessage(
            "validation:PASSWORD.minLowercase",
          ).toString();
        } else if (isStrongPassword(args.value, { minUppercase: 1 })) {
          return i18nValidationMessage(
            "validation:PASSWORD.minUppercase",
          ).toString();
        } else if (isStrongPassword(args.value, { minNumbers: 1 })) {
          return i18nValidationMessage(
            "validation:PASSWORD.minNumbers",
          ).toString();
        } else if (isStrongPassword(args.value, { minSymbols: 1 })) {
          return i18nValidationMessage(
            "validation:PASSWORD.minSymbols",
          ).toString();
        }
        return "";
      },
    },
  )
  password: string;
}

export class ChangePassword {
  @IsNotEmpty({ message: i18nValidationMessage("validation:NOT_EMPTY") })
  @IsString()
  code: string;

  @IsString()
  @IsNotEmpty({ message: i18nValidationMessage("validation:NOT_EMPTY") })
  password: string;

  @IsString()
  @IsNotEmpty({ message: i18nValidationMessage("validation:NOT_EMPTY") })
  passwordConfirmation: string;
}
